/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Ecosystem_NoteInputs */

const en_home_ecosystem_note = /** @type {(inputs: Home_Ecosystem_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`And your CRM, databases and internal applications. We check what can connect before proposing a system.`)
};

const lv_home_ecosystem_note = /** @type {(inputs: Home_Ecosystem_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un Jūsu CRM, datubāzēs un iekšējās lietotnēs. Pirms piedāvājam sistēmu, pārbaudām, ko iespējams savienot.`)
};

/**
* | output |
* | --- |
* | "And your CRM, databases and internal applications. We check what can connect before proposing a system." |
*
* @param {Home_Ecosystem_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_ecosystem_note = /** @type {((inputs?: Home_Ecosystem_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Ecosystem_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_ecosystem_note(inputs)
	return en_home_ecosystem_note(inputs)
});